import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const AssignmentResponsePageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: ${pxToRem(32)};
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06), 
              0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  display: flex;
  flex-direction: column;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Header = styled.div`
  margin-bottom: ${pxToRem(24)};

  h1 {
    font-size: ${pxToRem(32)};
    font-weight: 700;
    color: #1f0a35;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(32)};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
              0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const SectionTitle = styled.div`
  color: rgba(31, 10, 53, 0.5);
  font-size: ${pxToRem(16)};
  font-weight: 400;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${pxToRem(10)};
`;

export const ResponseText = styled.span`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 400;
`;

export const CommentInput = styled.textarea`
  width: 100%;
  padding: ${pxToRem(12)};
  border: none;
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(16)};
  outline: none;
  background: none;
`;

export const RatingStars = styled.div`
  font-size: ${pxToRem(24)};
  color: #ffc107;

  span {
    cursor: pointer;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(5)};
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(12)};
  text-decoration: none;
  background: rgb(235, 235, 235);
  max-width: fit-content;
  box-sizing: border-box;
`;

export const LinkItem = styled.a`
  align-items: center;
  gap: ${pxToRem(8)};
  color: #1f0a35;
  font-size: ${pxToRem(18)};
  font-weight: 400;
  text-decoration: none;
`;

export const LinkIcon = styled.img`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: ${pxToRem(32)};
`;

export const SaveButton = styled.button`
  border-radius: ${pxToRem(12)};
  background: rgb(114, 82, 220);
  padding: ${pxToRem(14)} ${pxToRem(28)};
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(18)};
  font-weight: 600;
  width: ${pxToRem(238)};
  cursor: pointer;

  &:hover {
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
`;
